<template>
  <div @click.stop="toggle()" class="header__toggle" id="header-mobile-toggle">
    <span id="header__toggle--open-button">Menu</span>
    <svg class="lightbox__close__icon" id="header__toggle--close-button"><use xlink:href="#close" /></svg>
  </div>
</template>

<script>
export default {
  props: {
    onToggle: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      toggled: false,
      scrollPosition: 0,
    };
  },
  methods: {
    toggleSnapEngage() {
      const snapEngage = document.querySelector('#snapengage-button') ||
        document.querySelector('#SnapABug_Button');
      if (!snapEngage) return;
      snapEngage.style.display = this.toggled ? 'block' : 'none';
    },

    toggleBackground() {
      const body = document.body;
      body.style.background = this.toggled ? '#1B2838' : '#FFFFFF';
      const classListAction = this.toggled ? 'remove': 'add';
      body.classList[classListAction]('mobile-nav-expanded');
    },

    toggleFooter() {
      const footer = document.querySelector('#footer');
      if (!footer) return;
      footer.style.display = this.toggled ? 'block' : 'none';
    },

    toggleMain() {
      const main = document.querySelector('#main');
      if (!main) return;
      main.style.display = this.toggled ? 'block' : 'none';
    },
    
    toggleMenuButtons() {
      document.querySelector('#header-mobile-toggle').classList.toggle('header__toggle--toggled');
    },

    toggle() {
      if (this.toggled) {
        this.toggleMain();
        this.toggleMenuButtons();
        this.toggleFooter();
        this.toggleSnapEngage();
        this.toggleBackground();
        window.scrollTo(0, this.scrollPosition);
        this.toggled = false;
      } else {
        this.scrollPosition = window.pageYOffset;
        this.toggleMain();
        this.toggleMenuButtons();
        this.toggleFooter();
        this.toggleSnapEngage();
        this.toggleBackground();
        this.toggled = true;
      }
      this.onToggle(this.toggled);
    },
  },
};
</script>
